import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Spare Part</Title>;
}
